import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { DefaultButton } from "@fluentui/react/lib/Button";
import { Text } from "@fluentui/react";
import type { IButtonStyles } from "@fluentui/react/lib/Button";
import * as React from "react";
import { styles } from "./FTL.styles";
import { strings } from "@src/i18n/strings";

const headerStrings = strings.components.ftlPanelHeader;

export function FtlPanelHeader({
  headerRef,
  onBack,
  onFeedbackClick,
  feedbackDisabled,
  feedbackIconName,
  feedbackButtonStyles,
}: {
  headerRef: React.RefObject<HTMLDivElement | null>;
  onBack: () => void;
  onFeedbackClick: () => void;
  feedbackDisabled: boolean;
  feedbackIconName?: string;
  feedbackButtonStyles: Partial<IButtonStyles>;
}): React.ReactElement {
  return (
    <Box
      ref={headerRef}
      sx={{
        ...styles.header,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Stack direction="row" alignItems="center">
        <DefaultButton
          text={headerStrings.back}
          onClick={onBack}
          allowDisabledFocus
          className="back-button"
          iconProps={{ iconName: "Back", styles: { root: styles.backIconRoot } }}
        />
        <Text variant="large" styles={{ root: styles.title }}>
          {headerStrings.title}
        </Text>
      </Stack>
      <DefaultButton
        text={headerStrings.feedback}
        iconProps={feedbackIconName ? { iconName: feedbackIconName } : undefined}
        onClick={onFeedbackClick}
        disabled={feedbackDisabled}
        styles={feedbackButtonStyles}
        title={headerStrings.feedbackTitle}
      />
    </Box>
  );
}
